import { render, staticRenderFns } from "./showLikesOrganizer.vue?vue&type=template&id=27806a6c"
import script from "./showLikesOrganizer.vue?vue&type=script&lang=js"
export * from "./showLikesOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports